export default {
  NO_NETWORK_CONNECTION_ERR: 'NO_NETWORK_CONNECTION_ERR',
  MISSING_LODGING_RISK_MAP: 'MISSING_LODGING_RISK_MAP',
  NO_DATA_GENERATED_YET: 'NO_DATA_GENERATED_YET',
  MISSING_GREEN_AREA_INDEX_MAP: 'MISSING_GREEN_AREA_INDEX_MAP',
  GENERIC_SERVICE_ISSUE: 'GENERIC_SERVICE_ISSUE',
};
